//Validation message
const EMAIL_VALIDATION_ERROR_MESSAGE =
    'Please enter a valid email, such as example@example.com'

export const getIsValidEmailAddress = (email: string) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return (
        re.test(String(email).toLowerCase()) || EMAIL_VALIDATION_ERROR_MESSAGE
    )
}
